import { Link } from "react-router-dom";
import { ArrowRight, Info } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "../components/Reveal";

const References = () => {
  const { t } = useLanguage();
  const r = t.referencesPage;

  return (
    <div className="bg-ink" data-testid="references-page">
      <section className="relative pt-40 pb-16 bg-ink-surface border-b border-white/5 bg-grid" data-testid="references-header">
        <div className="container-site">
          <p className="eyebrow">{r.eyebrow}</p>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white max-w-3xl leading-[1.05]">{r.title}</h1>
          <p className="mt-6 max-w-xl text-slate-400">{r.subtitle}</p>
        </div>
      </section>

      <section className="section-pad" data-testid="references-grid-section">
        <div className="container-site">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {t.industries.map((industry, i) => (
              <Reveal key={industry} delay={(i % 4) * 0.08}>
                <div className="card-dark p-8 flex flex-col items-center text-center gap-4 h-full hover:-translate-y-1" data-testid={`reference-card-${i + 1}`}>
                  <div className="w-16 h-16 border border-brand/40 bg-brand/5 flex items-center justify-center font-display font-bold text-brand text-xl">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <p className="font-display font-semibold text-white">{r.placeholderLabel} {String(i + 1).padStart(2, "0")}</p>
                  <p className="font-mono text-[11px] tracking-[0.2em] text-slate-400 uppercase">{industry}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-14 border border-brand/30 bg-brand/5 p-8 sm:p-10 flex flex-col md:flex-row md:items-center gap-6 justify-between" data-testid="references-note">
              <div className="flex items-start gap-4">
                <Info size={20} className="text-brand shrink-0 mt-1" />
                <p className="text-slate-300 leading-relaxed max-w-2xl">{r.note}</p>
              </div>
              <Link to="/contact" data-testid="references-cta-button" className="btn-primary shrink-0">
                {r.ctaButton} <ArrowRight size={16} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default References;
